import { render, staticRenderFns } from "./InTrayDocumentList.vue?vue&type=template&id=b9c6b2be"
import script from "./InTrayDocumentList.vue?vue&type=script&lang=js"
export * from "./InTrayDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports